import React from "react";
import {
  DISPLAY,
  FONT_SIZE,
  FONT_WEIGHT,
  SPACING,
} from "../../Constants/Enums/styles.enum";
import { Colors } from "../../Constants/colors";

interface Props {
  title: string;
}
const Pills = ({ title }: Props) => {
  // NEED TO ADD BADGE TYPE TO CHANGE COLOR OF THE PILL

  return (
    <div
      style={{
        display: DISPLAY.INLINE_BLOCK,
        padding: "4px 12px",
        borderRadius: SPACING.S12,
        backgroundColor: Colors.LIGHT_SUCCESS,
        fontSize: FONT_SIZE.F12,
        fontWeight: FONT_WEIGHT.MEDIUM,
        color: Colors.Success,
        maxWidth: "100px",
      }}
    >
      {title}
    </div>
  );
};
export default Pills;
